module.exports = __webpack_public_path__ + "static/media/history_5.06f7d68f.jpg";